import { useCallback, useEffect, useMemo, useState } from "react";
import AskAddyV2 from "../../models/askAddyV2";

// Same refresh as the v2 Autopilot panel, so a job's report shows up while the profile is open.
const POLL_MS = 20000;

/**
 * Autopilot's inbox and jobs for the signed-in loan officer. `inbox` and `jobs` stay null
 * until the first load; `isConnected` is false when this build has no Ask Addy v2 server.
 */
const useAutopilot = ({ organizationId, userId, loanId }) => {
  const [inbox, setInbox] = useState(null);
  const [jobs, setJobs] = useState(null);
  const [error, setError] = useState("");
  const isConnected = AskAddyV2.isEnabled() && !!organizationId && !!userId;
  const identity = useMemo(() => ({ organizationId, userId, loanId }), [organizationId, userId, loanId]);

  const reload = useCallback(async () => {
    if (!isConnected) {
      return;
    }
    try {
      const [nextInbox, nextJobs] = await Promise.all([
        AskAddyV2.autopilot.inbox(identity),
        AskAddyV2.autopilot.jobs(identity),
      ]);
      setInbox(nextInbox);
      setJobs(nextJobs);
      setError("");
    } catch (loadError) {
      setError(loadError.message);
    }
  }, [isConnected, identity]);

  useEffect(() => {
    reload();
    const timer = setInterval(reload, POLL_MS);
    return () => clearInterval(timer);
  }, [reload]);

  return { inbox, jobs, error, isConnected, identity, reload };
};

export default useAutopilot;
